"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkupManagerHost = void 0;
const LinkupAddress_1 = require("../LinkupAddress");
const LinkupManager_1 = require("../LinkupManager");
class LinkupManagerHost {
    constructor(eventCallback, linkup) {
        this.linkup = linkup || new LinkupManager_1.LinkupManager();
        this.eventCallback = eventCallback;
        this.newCallMessageCallback =
            (sender, recipient, callId, message) => {
                const ev = {
                    type: 'new-call-message',
                    sender: sender.url(),
                    recipient: recipient.url(),
                    callId: callId,
                    message: message
                };
                this.eventCallback(ev);
            };
        this.messageCallabcks = new Map();
        this.rawMessageCallback = (sender, recipient, message) => {
            const ev = {
                type: 'raw-message-event',
                sender: sender.url(),
                recipient: recipient.url(),
                message: message
            };
            this.eventCallback(ev);
        };
        this.listeningAddressesQueryCallback = (queryId, matches) => {
            const ev = {
                type: 'listening-addresses-query-response',
                queryId: queryId,
                matches: matches.map((addr) => addr.url())
            };
            this.eventCallback(ev);
        };
    }
    static isCommand(msg) {
        const type = msg === null || msg === void 0 ? void 0 : msg.type;
        return (type === 'listen-for-messages-new-call' ||
            type === 'listen-for-messages-on-call' ||
            type === 'listen-for-raw-messages' ||
            type === 'send-message-on-call' ||
            type === 'send-raw-message' ||
            type === 'listen-for-query-responses' ||
            type === 'query-for-listening-addresses');
    }
    static isEvent(msg) {
        const type = msg === null || msg === void 0 ? void 0 : msg.type;
        return (type === 'new-call-message' ||
            type === 'raw-message-event' ||
            type === 'listening-addresses-query-response' ||
            type === 'message-on-call');
    }
    execute(cmd) {
        if (cmd.type === 'listen-for-messages-new-call') {
            const listen = cmd;
            this.linkup.listenForMessagesNewCall(LinkupAddress_1.LinkupAddress.fromURL(listen.recipient), this.newCallMessageCallback);
        }
        else if (cmd.type === 'listen-for-messages-on-call') {
            const listen = cmd;
            const callback = (msg) => {
                const ev = {
                    type: 'message-on-call',
                    recipient: listen.recipient,
                    callId: listen.callId,
                    message: msg
                };
                this.eventCallback(ev);
            };
            this.linkup.listenForMessagesOnCall(LinkupAddress_1.LinkupAddress.fromURL(listen.recipient), listen.callId, callback);
        }
        else if (cmd.type === 'listen-for-raw-messages') {
            const listen = cmd;
            this.linkup.listenForRawMessages(LinkupAddress_1.LinkupAddress.fromURL(listen.recipient), this.rawMessageCallback);
        }
        else if (cmd.type === 'send-message-on-call') {
            const send = cmd;
            const sender = LinkupAddress_1.LinkupAddress.fromURL(send.sender);
            const recipient = LinkupAddress_1.LinkupAddress.fromURL(send.recipient);
            this.linkup.sendMessageOnCall(sender, recipient, send.callId, send.data);
        }
        else if (cmd.type === 'send-raw-message') {
            const send = cmd;
            const sender = LinkupAddress_1.LinkupAddress.fromURL(send.sender);
            const recipient = LinkupAddress_1.LinkupAddress.fromURL(send.recipient);
            this.linkup.sendRawMessage(sender, recipient, send.data, send.sendLimit);
        }
        else if (cmd.type === 'listen-for-query-responses') {
            const listen = cmd;
            this.linkup.listenForQueryResponses(listen.queryId, this.listeningAddressesQueryCallback);
        }
        else if (cmd.type === 'query-for-listening-addresses') {
            let query = cmd;
            this.linkup.queryForListeningAddresses(query.queryId, query.addresses.map((ep) => LinkupAddress_1.LinkupAddress.fromURL(ep)));
        }
    }
}
exports.LinkupManagerHost = LinkupManagerHost;
//# sourceMappingURL=LinkupManagerHost.js.map